import { LoggerGenericFn, LoggerMethod } from './loggerTypes';

export const getBoundConsole = (method: LoggerMethod): LoggerGenericFn => {
  const boundConsole = console[method].bind(console); // eslint-disable-line no-console

  return (message, data) => {
    if (data) {
      boundConsole(message, data);
    } else {
      boundConsole(message); // keeps "undefined" out of the console
    }
  };
};
